var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2822 15C21.2822 15.5304 21.0715 16.0391 20.6964 16.4142C20.3214 16.7893 19.8127 17 19.2822 17H7.28223L3.28223 21V5C3.28223 4.46957 3.49294 3.96086 3.86801 3.58579C4.24309 3.21071 4.75179 3 5.28223 3H19.2822C19.8127 3 20.3214 3.21071 20.6964 3.58579C21.0715 3.96086 21.2822 4.46957 21.2822 5V15Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquare);
export default __webpack_public_path__ + "static/media/message-square.79bec8ccd0824a452aa42f4325bff08d.svg";
export { ForwardRef as ReactComponent };